import { render, staticRenderFns } from "./LikesTotal.vue?vue&type=template&id=5d8b0644&"
import script from "./LikesTotal.vue?vue&type=script&lang=js&"
export * from "./LikesTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports